import { connect } from 'react-redux/dist/react-redux';
import Proposition from '../components/Proposition';

function mapStateToProps(state) {
    return {
        langues: state.demandeCredit.getIn(['langues', 'value']), 
    };
  }
export default connect(mapStateToProps)(Proposition);
